// Module
var code = "<select ng-model=\"vm.model\" class=\"b-select\" ng-options=\"key as value for (key, value) in vm.options\" data-search=\"true\"></select> ";
// Exports
module.exports = code;